import { api } from "./_client";

export async function adminStats() {
    const { data } = await api.get("/admin/stats");
    return data;
}

export async function adminUsers() {
    const { data } = await api.get("/admin/users");
    return data.users || [];
}

export async function adminProjects() {
    const { data } = await api.get("/admin/projects");
    return data.projects || [];
}

export async function adminImpersonate(userId) {
    const { data } = await api.post(`/admin/impersonate/${userId}`);
    return data; // { access_token, target_user }
}

// iter-46 admin extras

export async function adminUpdateBranding(patch) {
    const { data } = await api.patch("/admin/branding", patch);
    return data.branding;
}

export async function adminUploadLogo(file) {
    const form = new FormData();
    form.append("file", file);
    const { data } = await api.post("/admin/branding/logo", form, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
}

// iter-62: upload one of the three hero videos (upload / analyze / estimate).

export async function adminUploadBrandingVideo(slot, file, onProgress) {
    const form = new FormData();
    form.append("file", file);
    const { data } = await api.post(
        `/admin/branding/video/${slot}`,
        form,
        {
            headers: { "Content-Type": "multipart/form-data" },
            onUploadProgress: (e) => {
                if (onProgress && e.total) {
                    onProgress(Math.round((e.loaded / e.total) * 100));
                }
            },
        },
    );
    return data;
}

export async function adminListIntegrations() {
    const { data } = await api.get("/admin/integrations");
    return data; // { integrations, ai_default_provider }
}

export async function adminUpdateIntegrations(values) {
    const { data } = await api.patch("/admin/integrations", values);
    return data; // { integrations, ai_default_provider }
}

export async function adminSetAiDefault(providerId) {
    const { data } = await api.patch("/admin/ai-default", {
        provider_id: providerId,
    });
    return data.ai_default_provider;
}

export async function adminGetReviewerStatus() {
    const { data } = await api.get("/admin/reviewer-status");
    return data; // { enabled, disabled }
}

export async function adminSetReviewerStatus(enabled) {
    const { data } = await api.patch("/admin/reviewer-status", { enabled });
    return data; // { enabled, disabled }
}

// ============================================================
// iter-97 — Security tab (abuse prevention + soft-delete)
// ============================================================

export async function adminGetSecurityConfig() {
    const { data } = await api.get("/admin/security");
    return data;
}

export async function adminSetSecurityConfig(payload) {
    const { data } = await api.patch("/admin/security", payload);
    return data;
}

export async function adminListAbuseEvents(limit = 200) {
    const { data } = await api.get(`/admin/abuse-events?limit=${limit}`);
    return data; // { events, count }
}

export async function adminClearAbuseEvents() {
    const { data } = await api.delete("/admin/abuse-events");
    return data;
}

export async function adminDisableUser(userId) {
    const { data } = await api.post(`/admin/users/${userId}/disable`);
    return data;
}

export async function adminReactivateUser(userId) {
    const { data } = await api.post(`/admin/users/${userId}/reactivate`);
    return data;
}

// User-facing: soft-delete the current account.

export async function adminListCreditPacks() {
    const { data } = await api.get("/admin/credit-packs");
    return Array.isArray(data) ? data : [];
}

export async function adminCreateCreditPack(payload) {
    const { data } = await api.post("/admin/credit-packs", payload);
    return data;
}

export async function adminUpdateCreditPack(id, patch) {
    const { data } = await api.patch(`/admin/credit-packs/${id}`, patch);
    return data;
}

export async function adminDeleteCreditPack(id) {
    await api.delete(`/admin/credit-packs/${id}`);
}

export async function adminGrantPack(userId, packId) {
    const { data } = await api.post(`/admin/users/${userId}/grant-pack`, {
        pack_id: packId,
    });
    return data;
}

export async function adminListPromoCodes() {
    const { data } = await api.get("/admin/promo-codes");
    return Array.isArray(data) ? data : [];
}

export async function adminCreatePromoCode(payload) {
    const { data } = await api.post("/admin/promo-codes", payload);
    return data;
}

export async function adminUpdatePromoCode(id, patch) {
    const { data } = await api.patch(`/admin/promo-codes/${id}`, patch);
    return data;
}

export async function adminDeletePromoCode(id) {
    await api.delete(`/admin/promo-codes/${id}`);
}

// iter-96: free-tier config + per-tier AI provider override

export async function adminGetFreeTier() {
    const { data } = await api.get("/admin/free-tier");
    return data; // { enabled, credits, provider }
}

export async function adminSetFreeTier(payload) {
    const { data } = await api.patch("/admin/free-tier", payload);
    return data;
}

// Stable list of AI provider ids used in tier / free-tier dropdowns.
// Mirrors backend settings.INTEGRATION_KEYS provider_ids.

export async function adminUpdateUserRole(userId, role) {
    const { data } = await api.patch(`/admin/users/${userId}/role`, { role });
    return data;
}

export async function adminBanUser(userId, { ban_ip = true } = {}) {
    const { data } = await api.post(`/admin/users/${userId}/ban`, { ban_ip });
    return data;
}

export async function adminUnbanUser(userId) {
    const { data } = await api.post(`/admin/users/${userId}/unban`);
    return data;
}

export async function adminDeleteUser(userId) {
    const { data } = await api.delete(`/admin/users/${userId}`);
    return data;
}


// ----- Workgroups, Invites, Notifications (shared team workspaces) -----

export async function adminListSubscriptionTiers() {
    const { data } = await api.get("/admin/subscription-tiers");
    return data.tiers || [];
}

export async function adminCreateSubscriptionTier(payload) {
    const { data } = await api.post("/admin/subscription-tiers", payload);
    return data;
}

export async function adminUpdateSubscriptionTier(tierId, patch) {
    const { data } = await api.patch(
        `/admin/subscription-tiers/${tierId}`,
        patch,
    );
    return data;
}

export async function adminDeleteSubscriptionTier(tierId) {
    const { data } = await api.delete(`/admin/subscription-tiers/${tierId}`);
    return data;
}

export async function adminUploadSubscriptionTierImage(tierId, file) {
    const form = new FormData();
    form.append("file", file);
    const { data } = await api.post(
        `/admin/subscription-tiers/${tierId}/image`,
        form,
        { headers: { "Content-Type": "multipart/form-data" } },
    );
    return data;
}

export async function adminGetAiCreditRates() {
    const { data } = await api.get("/admin/ai-credit-rates");
    return data.rates || {};
}

export async function adminUpdateAiCreditRates(rates) {
    const { data } = await api.patch("/admin/ai-credit-rates", rates);
    return data.rates || {};
}

export async function adminListUsersWithSubscriptions() {
    const { data } = await api.get("/admin/users-with-subscriptions");
    return data.users || [];
}

export async function adminGrantCredits(userId, credits, note = "") {
    const { data } = await api.post(
        `/admin/users/${userId}/grant-credits`,
        { credits, note },
    );
    return data;
}

export async function adminGiftSubscription(userId, tierId, durationDays, note = "") {
    const payload = { tier_id: tierId, note };
    if (durationDays != null) payload.duration_days = Number(durationDays);
    const { data } = await api.post(
        `/admin/users/${userId}/gift-subscription`,
        payload,
    );
    return data;
}

export async function adminExtendSubscription(userId, days) {
    const { data } = await api.post(
        `/admin/users/${userId}/extend-subscription`,
        { days: Number(days) },
    );
    return data;
}

export async function adminCancelSubscription(userId) {
    const { data } = await api.post(
        `/admin/users/${userId}/cancel-subscription`,
    );
    return data;
}
// -------- Workgroups (iter-119) --------

export async function adminListWorkgroups() {
    const { data } = await api.get("/admin/workgroups");
    return data || [];
}

export async function adminDeleteWorkgroup(wgId) {
    const { data } = await api.delete(`/admin/workgroups/${wgId}`);
    return data;
}

// iter-153 — superadmin force-adds an existing user to a workgroup,
// bypassing the invite flow.
export async function adminAddWorkgroupMember(wgId, userId, role = "member") {
    const { data } = await api.post(`/admin/workgroups/${wgId}/members`, {
        user_id: userId,
        role,
    });
    return data;
}

// -------- Feature flags ("Future" admin tab) --------

export async function adminGetFeatureFlags() {
    const { data } = await api.get("/admin/feature-flags");
    return data.flags || {};
}

export async function adminUpdateFeatureFlags(flags) {
    const { data } = await api.patch("/admin/feature-flags", flags);
    return data.flags || {};
}

// -------- Storage usage (iter-114) --------

// Current user's storage usage + cap. Powers the "Storage used" pill in
// the account dropdown menu. ``cap_bytes`` of 0 means unlimited.
export async function getMyStorageUsage() {
    const { data } = await api.get("/me/storage-usage");
    return data || { used_bytes: 0, cap_bytes: 0, exempt: false };
}

// -------- Global settings (Admin → Settings tab, iter-112) --------

export async function adminGetGlobalSettings() {
    const { data } = await api.get("/admin/global-settings");
    return data || {};
}

export async function adminUpdateGlobalSettings(patch) {
    const { data } = await api.patch("/admin/global-settings", patch);
    return data || {};
}
